var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('v-chip',{staticClass:"font-weight-bold px-2",attrs:{"label":"","x-small":"","color":"deep-purple darken-1","text-color":"white"}},[_vm._v(" Non Bonded ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }